import {
    STORE_DATA_CRAFTER_TEMPLATES,
    STORE_DATA_CRAFTER_TEMPLATE_FORM,
    STORE_DATA_CRAFTER_SCRIPT_COMPILATION,
    STORE_DATA_CRAFTER_OUTPUT_VARIANTS
} from './constants';
import { RootStores } from '../../common/stores';
import DataCrafterTemplatesVisualStore from './DataCrafterTemplatesVisualStore';
import DataCrafterTemplateFormStore from './DataCrafterTemplateFormStore';
import DataCrafterScriptCompilationStore from './DataCrafterScriptCompilationStore';
import DataCrafterOutputVariantsStore from './DataCrafterOutputVariantsStore';
import { DataCrafterTemplatesService } from '../services';
import { STORE_PROJECTS_ROOT_UI, STORE_ROUTER, STORE_USERS } from '../../common/constants';
import { ProjectsService } from '../../common/services';
import { MLService } from '../../ml_models/services';

export { default as DataCrafterTemplatesVisualStore } from './DataCrafterTemplatesVisualStore';
export { default as DataCrafterTemplateFormStore } from './DataCrafterTemplateFormStore';
export { default as DataCrafterScriptCompilationStore } from './DataCrafterScriptCompilationStore';
export { default as DataCrafterOutputVariantsStore } from './DataCrafterOutputVariantsStore';

export function injectDataCrafterTemplatesStores(obj: RootStores) {
    const dataCrafterTemplatesService = new DataCrafterTemplatesService();
    const projectsService = new ProjectsService();
    const mlService = new MLService();

    const visualStore = new DataCrafterTemplatesVisualStore(
        obj[STORE_PROJECTS_ROOT_UI],
        dataCrafterTemplatesService,
        obj[STORE_ROUTER],
        projectsService,
        obj[STORE_USERS]
    );

    const scriptCompilationStore = new DataCrafterScriptCompilationStore(dataCrafterTemplatesService);
    const outputVariantsStore = new DataCrafterOutputVariantsStore(visualStore);

    obj[STORE_DATA_CRAFTER_TEMPLATES] = visualStore;
    obj[STORE_DATA_CRAFTER_OUTPUT_VARIANTS] = outputVariantsStore;
    obj[STORE_DATA_CRAFTER_TEMPLATE_FORM] = new DataCrafterTemplateFormStore(
        visualStore,
        dataCrafterTemplatesService,
        mlService,
        scriptCompilationStore,
        outputVariantsStore
    );
    obj[STORE_DATA_CRAFTER_SCRIPT_COMPILATION] = scriptCompilationStore;
}

export type DataCrafterTemplatesStores = {
    [STORE_DATA_CRAFTER_TEMPLATES]?: DataCrafterTemplatesVisualStore;
    [STORE_DATA_CRAFTER_TEMPLATE_FORM]?: DataCrafterTemplateFormStore;
    [STORE_DATA_CRAFTER_SCRIPT_COMPILATION]?: DataCrafterScriptCompilationStore;
    [STORE_DATA_CRAFTER_OUTPUT_VARIANTS]?: DataCrafterOutputVariantsStore;
};
